import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { FEATURES } from "../data/content";

const Icon = ({ name, ...props }) => {
  const C = Icons[name] || Icons.Check;
  return <C {...props} />;
};

export const FeaturesBar = () => {
  return (
    <section data-testid="features-bar" className="bg-primary text-primary-foreground border-b border-white/10">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              data-testid={`feature-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-3 py-6 px-4 lg:px-6"
            >
              <span className="flex items-center justify-center w-10 h-10 rounded-sm bg-[hsl(var(--brand-green))]/20 text-[hsl(var(--brand-green))] shrink-0">
                <Icon name={f.icon} className="w-5 h-5" />
              </span>
              <span className="text-sm font-semibold leading-tight">{f.title}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
